var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ArrayInput',{attrs:{"default":"1.0","min":_vm.schema.min,"max":_vm.schema.max},on:{"validate":function($event){_vm.isArrayValid = $event}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
var onInput = ref.onInput;
return [_c('b-form-input',{staticClass:"k-input",attrs:{"type":"number","value":item},on:{"change":onInput}})]}}]),model:{value:(_vm.array),callback:function ($$v) {_vm.array=$$v},expression:"array"}})}
var staticRenderFns = []

export { render, staticRenderFns }